/* SBHY - Variant media filter (Dawn-safe) */
(() => {
  const DEBUG = true;

  const norm = (s) =>
    (s || "")
      .toString()
      .trim()
      .toLowerCase()
      .replace(/\s+/g, "-");

  function log(...args) {
    if (DEBUG) console.log("[SBHY media filter]", ...args);
  }

  function getColorFromAlt(altRaw) {
    const alt = (altRaw || "").toLowerCase();

    // supports: "color:bone"  OR  "#color_bone" / "color-bone"
    if (alt.includes("color:all")) return "all";

    let m = alt.match(/color\s*:\s*([a-z0-9_-]+)/i);
    if (m) return norm(m[1]);

    m = alt.match(/#?color[_-]([a-z0-9_-]+)/i);
    if (m) return norm(m[1]);

    return ""; // untagged = show for all
  }

  function getSelectedColor() {
    // Dawn typically renders options inside variant-selects/variant-radios
    const root =
      document.querySelector("variant-selects") ||
      document.querySelector("variant-radios") ||
      document;

    // Find the option group whose legend contains "color"
    const fieldsets = Array.from(root.querySelectorAll("fieldset"));
    const colorFs = fieldsets.find((fs) => {
      const legend = fs.querySelector("legend");
      return legend && legend.textContent.toLowerCase().includes("color");
    });

    if (colorFs) {
      const checked = colorFs.querySelector('input[type="radio"]:checked');
      if (checked?.value) return norm(checked.value);

      const sel = colorFs.querySelector("select");
      if (sel?.value) return norm(sel.value);
    }

    // Fallback: first checked radio anywhere in product form area
    const anyChecked =
      document.querySelector('.product-form input[type="radio"]:checked') ||
      document.querySelector('input[type="radio"]:checked');
    if (anyChecked?.value) return norm(anyChecked.value);

    return "";
  }

  function setHidden(el, hide) {
    if (!el) return;
    el.hidden = !!hide; // important for Dawn sliders
    el.style.display = hide ? "none" : "";
    el.setAttribute("aria-hidden", hide ? "true" : "false");
  }

  function filter() {
    const selected = getSelectedColor();
    if (!selected) {
      log("No selected color found (nothing filtered).");
      return;
    }

    log("Selected color:", selected);

    // Main media items
    const mediaItems = Array.from(
      document.querySelectorAll("li.product__media-item[data-media-id]")
    );

    // Thumbnails
    const thumbs = Array.from(
      document.querySelectorAll("li.thumbnail-list__item")
    );

    const applyToList = (items) => {
      items.forEach((item) => {
        const img = item.querySelector("img");
        const tag = getColorFromAlt(img?.getAttribute("alt") || "");
        const show = !tag || tag === "all" || tag === selected;
        setHidden(item, !show);
      });
    };

    applyToList(mediaItems);
    applyToList(thumbs);

    // If currently displayed media is hidden, jump to first visible thumbnail
    const firstVisibleThumb = thumbs.find((t) => !t.hidden);
    const activeThumbHidden = thumbs.some((t) => t.classList.contains("is-active") && t.hidden);

    if (firstVisibleThumb && activeThumbHidden) {
      const btn =
        firstVisibleThumb.querySelector("button") ||
        firstVisibleThumb.querySelector("a");
      if (btn) btn.click();
    }
  }

  function runSoon() {
    // Dawn re-renders product-info via fetch; run after the DOM settles
    window.requestAnimationFrame(() => setTimeout(filter, 30));
  }

  document.addEventListener("DOMContentLoaded", () => {
    log("Loaded");
    runSoon();
  });

  // Re-run on any option change
  document.addEventListener("change", (e) => {
    if (e.target.closest("variant-selects, variant-radios, .product-form")) {
      runSoon();
    }
  });

  // Dawn emits this on some versions
  document.addEventListener("variant:change", runSoon);

  // Theme editor section reloads
  document.addEventListener("shopify:section:load", runSoon);
})();

